import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        const title = this.props.disableTitleSuffix
            ? this.props.pageTitle
            : `${this.props.pageTitle} | Product Lead`;

        return(
            <React.Fragment>
                <Helmet>
                    <title>{title}</title>
                    <meta name="description" content="Product Lead helping teams with product strategy, UX, leadership, mentorship, and AI-powered product building." />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
